import { AppRouter } from './app/AppRouter';

async function bootstrap(): Promise<void> {
  const container = document.getElementById('app');
  if (!container) throw new Error('main.ts: #app container not found in index.html');
  new AppRouter(container).start();
}

bootstrap().catch((err: unknown) => {
  console.error(err);
  const container = document.getElementById('app');
  if (container) {
    const message = err instanceof Error ? (err.stack ?? err.message) : String(err);
    container.innerHTML = `<pre style="color:#fff;background:#a00;padding:16px;font-family:monospace;">${message}</pre>`;
  }
});
